import { RadioGroup } from "@/ds";
import { ConfirmarSituacaoDialog } from "@/shared/components";
import styles from "./inativar-ativar-referencia.module.scss";
import type { InativarAtivarReferenciaViewModel } from "./types-inativar-ativar-referencia";

export function InativarAtivarReferenciaView({
  acao,
  titulo,
  subtitulo,
  confirmLabel,
  tituloEfeitos,
  oQueAcontece,
  identificacao,
  escopo,
  onConfirmar,
  onCancelar,
}: InativarAtivarReferenciaViewModel) {
  return (
    <ConfirmarSituacaoDialog
      acao={acao}
      titulo={titulo}
      subtitulo={subtitulo}
      confirmLabel={confirmLabel}
      tituloEfeitos={tituloEfeitos}
      oQueAcontece={oQueAcontece}
      corpo={
        <div className={styles.identificacao} data-testid="inativar-ativar-identificacao">
          <p className={styles.intro}>{identificacao.intro}</p>
          <p className={styles.titulo}>
            <strong>{identificacao.titulo}</strong>
          </p>
          {escopo ? (
            <RadioGroup.Root
              value={escopo.valor}
              onChange={escopo.escolher}
              aria-label={escopo.rotulo}
              testId="inativar-ativar-escopo"
            >
              {escopo.opcoes.map((opcao) => (
                <RadioGroup.Item
                  key={opcao.valor}
                  value={opcao.valor}
                  label={opcao.rotulo}
                  testId={`inativar-ativar-escopo-${opcao.valor}`}
                />
              ))}
            </RadioGroup.Root>
          ) : null}
        </div>
      }
      onConfirmar={onConfirmar}
      onCancelar={onCancelar}
    />
  );
}
